var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config',{on:{"submit":function($event){return _vm.update($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }